import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadableDspError = loadable(() => import('./DspError'), {
  fallback: <LoadingScreen />,
});

export default LoadableDspError;
